import { type MouseEvent, type ReactElement, useCallback } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';

import { sendMessage } from '@/features/app/MessageHandler';

const MFE_SHOW_POPOVER = 'MFE/SHOW_POPOVER';
const MFE_HIDE_POPOVER = 'MFE/HIDE_POPOVER';

const iFrameId = window.location.origin;

interface ParentPopoverProps {
    title: string;
    content: ReactElement;
    children: ReactElement;
}

const ParentPopover = ({ title, content, children }: ParentPopoverProps) => {
    const handleMouseEnter = useCallback(
        (event: MouseEvent<HTMLSpanElement>) => {
            const rect = event.currentTarget.getBoundingClientRect();
            const html = renderToStaticMarkup(content);

            sendMessage({
                type: MFE_SHOW_POPOVER,
                payload: {
                    iFrameId,
                    title,
                    html,
                    triggerRect: {
                        top: rect.top,
                        left: rect.left,
                        width: rect.width,
                        height: rect.height,
                    },
                },
            });
        },
        [title, content],
    );

    const handleMouseLeave = useCallback(() => {
        sendMessage({
            type: MFE_HIDE_POPOVER,
            payload: { iFrameId },
        });
    }, []);

    return (
        <span onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            {children}
        </span>
    );
};

export default ParentPopover;
